import { IRolePageLang } from '../../../types/lang'

export const rolePageLang: IRolePageLang = {
	role_page: {
		btn_add_new: 'Add New',
		btn_delete_multiple_items: 'Delete {{cnt}} items'
	}
}